// extracted by mini-css-extract-plugin
module.exports = {"form-message":"FormMessage_form-message__lTbvI","form-message--error":"FormMessage_form-message--error__2KRtf","form-message--success":"FormMessage_form-message--success__1-H6W"};